// extracted by mini-css-extract-plugin
export default {"columns":"UserList_columns__AQuPr","userTd":"UserList_userTd__27+py","capitalizeText":"UserList_capitalizeText__97uqi","action":"UserList_action__jUcwd"};